import { render } from "./AdvanceDone.vue?vue&type=template&id=99842910"
import script from "./AdvanceDone.vue?vue&type=script&lang=js"
export * from "./AdvanceDone.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src766051562/src/medoor-medical-records/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__